// extracted by mini-css-extract-plugin
export default {"calendarSpan":"Ge9a3f3","calendarIcon":"G6558db"};